<div class="flex justify-center gap-5">
<chart-donut></chart-donut>
<chart-bar style="align-content: center;"></chart-bar>
</div>